"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.____LawNum = void 0;
const __1 = require("..");
class ____LawNum extends __1.EL {
    tag = "____LawNum";
    get isControl() { return true; }
    children;
    constructor(text, range = null) {
        super("____LawNum", {}, [], range);
        this.children = [text];
    }
}
exports.____LawNum = ____LawNum;
//# sourceMappingURL=lawNum.js.map